import { create } from 'zustand';
import { DateRange } from 'react-day-picker';
import { ColumnState } from 'ag-grid-community';
import { getCurrentMonthDateRange } from 'src/utils/date/dateUtils';
import { defaultTQC2050_R01HeaderDto, defaultTQC2050_R01DetailDto, TQC2050_R01HeaderDto, TQC2050_R01DetailDto } from './Dto_TQC2050_R01';
import { allCd, useCommonCodeStore } from 'src/store/useCommonCodeStore';

export interface TQC2050_R01Filter {
    compCd: string;           // 사업장
    testDt: DateRange | undefined; // 시험기간(범위)
    empNo: string;            // 시험자
    empNm: string;            // 시험자명
    carModel: string;         // 차종
    equipmentCd: string;      // 시험기기
}

export interface Store_TQC2050_R01 {
	TQC2050_R01Filter: TQC2050_R01Filter;
	TQC2050_R01PastFilter: TQC2050_R01Filter;
	setTQC2050_R01Filter: (filter: Partial<TQC2050_R01Filter>) => void;
	setTQC2050_R01PastFilter: (filter: Partial<TQC2050_R01Filter>) => void;

	TQC2050_R01List: TQC2050_R01HeaderDto[];
	setTQC2050_R01List: (TQC2050_R01List: TQC2050_R01HeaderDto[]) => void;

	selectedTQC2050_R01: TQC2050_R01HeaderDto | undefined;
	setSelectedTQC2050_R01: (item: TQC2050_R01HeaderDto | undefined) => void;
	initSelectedTQC2050_R01: () => void;

	editTQC2050_R01: TQC2050_R01HeaderDto | null;
	setEditTQC2050_R01: (item: TQC2050_R01HeaderDto | null) => void;

	// ====== 디테일 관리 ======
	TQC2050_R01DetailList: TQC2050_R01DetailDto[];
	setTQC2050_R01DetailList: (data: TQC2050_R01DetailDto[]) => void;
	insertTQC2050_R01DetailList: (data: TQC2050_R01DetailDto[], index?: number) => void;
	removeTQC2050_R01DetailList: (valueIndex: number) => void;
	updateTQC2050_R01DetailList: (valueIndex: number, data: TQC2050_R01DetailDto) => void;

	selectedTQC2050_R01DetailList: string[];
	setSelectedTQC2050_R01DetailList: (idList: string[]) => void;
	addSelectedTQC2050_R01DetailList: (idList: string[]) => void;
	removeSelectedTQC2050_R01DetailList: (idList?: string[]) => void;
	initSelectedTQC2050_R01DetailList: () => void;

	deletedTQC2050_R01DetailList: string[];
	setDeletedTQC2050_R01DetailList: (idList: string[]) => void;
	addDeletedTQC2050_R01DetailList: (idList: string[]) => void;
	removeDeletedTQC2050_R01DetailList: (idList?: string[]) => void;

	originalTQC2050_R01DetailList: TQC2050_R01DetailDto[];
	setOriginalTQC2050_R01DetailList: (data: TQC2050_R01DetailDto[]) => void;

	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	
	// ====== DetailTable 상태 관리 ======
	prevSampleCount: number | undefined;
	setPrevSampleCount: (count: number | undefined) => void;
	isEditing: boolean;
	setIsEditing: (editing: boolean) => void;
	prevTestDetails: TQC2050_R01DetailDto[] | undefined;
	setPrevTestDetails: (details: TQC2050_R01DetailDto[] | undefined) => void;

	// ====== 두 번째 DetailTable 관리 ======
	TQC2050_R01DetailList2: TQC2050_R01DetailDto[];
	setTQC2050_R01DetailList2: (data: TQC2050_R01DetailDto[]) => void;
	insertTQC2050_R01DetailList2: (data: TQC2050_R01DetailDto[], index?: number) => void;
	removeTQC2050_R01DetailList2: (valueIndex: number) => void;
	updateTQC2050_R01DetailList2: (valueIndex: number, data: TQC2050_R01DetailDto) => void;

	selectedTQC2050_R01DetailList2: string[];
	setSelectedTQC2050_R01DetailList2: (idList: string[]) => void;
	addSelectedTQC2050_R01DetailList2: (idList: string[]) => void;
	removeSelectedTQC2050_R01DetailList2: (idList?: string[]) => void;
	initSelectedTQC2050_R01DetailList2: () => void;

	deletedTQC2050_R01DetailList2: string[];
	setDeletedTQC2050_R01DetailList2: (idList: string[]) => void;
	addDeletedTQC2050_R01DetailList2: (idList: string[]) => void;
	removeDeletedTQC2050_R01DetailList2: (idList?: string[]) => void;

	originalTQC2050_R01DetailList2: TQC2050_R01DetailDto[];
	setOriginalTQC2050_R01DetailList2: (data: TQC2050_R01DetailDto[]) => void;

	detailColumnState2: ColumnState[] | null;
	setDetailColumnState2: (state: ColumnState[] | null) => void;

	prevSampleCount2: number | undefined;
	setPrevSampleCount2: (count: number | undefined) => void;
	isEditing2: boolean;
	setIsEditing2: (editing: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	detailScrollTop2: number | null;
	setDetailScrollTop2: (top: number | null) => void;

	initData: () => void;
}

export const defaultTQC2050_R01Filter : TQC2050_R01Filter = {
    compCd: '',
    testDt: getCurrentMonthDateRange(),
    empNo: '',
    empNm: '',
    carModel: '',
    equipmentCd: ''
};

export const useTQC2050_R01Store = create<Store_TQC2050_R01>((set) => ({
	TQC2050_R01Filter: defaultTQC2050_R01Filter,
	TQC2050_R01PastFilter: defaultTQC2050_R01Filter,
	setTQC2050_R01Filter: (filter: Partial<TQC2050_R01Filter>) => set((state) =>  ({
		...state,
		TQC2050_R01Filter: {
			...state.TQC2050_R01Filter,
			...filter
		}	
	})),
	setTQC2050_R01PastFilter: (filter: Partial<TQC2050_R01Filter>) => set((state) =>  ({
		...state,
		TQC2050_R01PastFilter: {
			...state.TQC2050_R01PastFilter,
			...filter
		}	
	})),

	TQC2050_R01List: [],
	setTQC2050_R01List: (TQC2050_R01List: TQC2050_R01HeaderDto[]) => set({ TQC2050_R01List }),

	selectedTQC2050_R01: undefined,
	setSelectedTQC2050_R01: (item: TQC2050_R01HeaderDto | undefined) => set((state) => {

		return { 
			selectedTQC2050_R01: item, 
			selectedTQC2050_R01DetailList: [], 
			deletedTQC2050_R01DetailList: [],
			selectedTQC2050_R01DetailList2: [],
			deletedTQC2050_R01DetailList2: [],
			detailScrollTop: null,
			detailScrollTop2: null,
		};
	}),
	initSelectedTQC2050_R01: () => set({ selectedTQC2050_R01: undefined, editTQC2050_R01: defaultTQC2050_R01HeaderDto }),
	
	editTQC2050_R01: defaultTQC2050_R01HeaderDto,
	setEditTQC2050_R01: (item: TQC2050_R01HeaderDto | null) => set((state) => {
		let editData = defaultTQC2050_R01HeaderDto;
		if (item) {
			editData = { ...item };
		}
		return { editTQC2050_R01: editData };
	}),

	// ====== 디테일 관리 ======
	TQC2050_R01DetailList: [],
	setTQC2050_R01DetailList: (data: TQC2050_R01DetailDto[]) => set((state) => {
		let newList: TQC2050_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach(item => {
			newList.push({
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return { ...state, TQC2050_R01DetailList: newList };
	}),
	insertTQC2050_R01DetailList: (data: TQC2050_R01DetailDto[], index?: number) => set((state) => {
		const newList = [...state.TQC2050_R01DetailList];
		let valueIndex = Math.max(0, ...newList.map(i => i.valueIndex || 0)) + 1;
		let targetOrderIndex = index ? index : 1;
		const maxSeq = Math.max(0, ...newList.filter(i => i.orderIndex === targetOrderIndex).map(i => i.orderIndexSeq || 0));
		let targetSeq = maxSeq + 1;
		const toInsert = data.map(item => ({ ...defaultTQC2050_R01DetailDto, ...item, valueIndex: valueIndex++, orderIndex: targetOrderIndex, orderIndexSeq: targetSeq }));
		if (index !== undefined) newList.splice(index, 0, ...toInsert); else newList.push(...toInsert);
		return { TQC2050_R01DetailList: newList };
	}),
	removeTQC2050_R01DetailList: (valueIndex: number) => set((state) => ({
		TQC2050_R01DetailList: [...state.TQC2050_R01DetailList].filter(item => item.valueIndex !== valueIndex)
	})),
	updateTQC2050_R01DetailList: (valueIndex: number, data: TQC2050_R01DetailDto) => set((state) => ({
		TQC2050_R01DetailList: state.TQC2050_R01DetailList.map(item => item.valueIndex === valueIndex ? data : item)
	})),

	selectedTQC2050_R01DetailList: [],
	setSelectedTQC2050_R01DetailList: (idList: string[]) => set((state) => ({
		...state,
		selectedTQC2050_R01DetailList: idList,
	})),
	addSelectedTQC2050_R01DetailList: (idList: string[]) => set((state) => ({
		selectedTQC2050_R01DetailList: [...state.selectedTQC2050_R01DetailList, ...idList]
	})),
	removeSelectedTQC2050_R01DetailList: (idList?: string[]) => set((state) => ({
		selectedTQC2050_R01DetailList: [...state.selectedTQC2050_R01DetailList].filter(v => idList ? !idList.includes(v) : false)
	})),
	initSelectedTQC2050_R01DetailList: () => set({ selectedTQC2050_R01DetailList: [] }),

	deletedTQC2050_R01DetailList: [],
	setDeletedTQC2050_R01DetailList: (idList: string[]) => set({ deletedTQC2050_R01DetailList: idList }),
	addDeletedTQC2050_R01DetailList: (idList: string[]) => set((state) => {
		const _deleted = [...state.deletedTQC2050_R01DetailList];
		for (const v of idList) {
			const isInserted = state.TQC2050_R01DetailList.find(it => it.valueIndex === Number(v) && it.inserted);
			const isModified = state.TQC2050_R01DetailList.find(it => it.valueIndex === Number(v) && it.isModified);
			if (!isInserted && !isModified) _deleted.push(v);
		}
		return { deletedTQC2050_R01DetailList: _deleted };
	}),
	removeDeletedTQC2050_R01DetailList: (idList?: string[]) => set((state) => ({
		deletedTQC2050_R01DetailList: [...state.deletedTQC2050_R01DetailList].filter(v => idList ? !idList.includes(v) : false)
	})),

	originalTQC2050_R01DetailList: [],
	setOriginalTQC2050_R01DetailList: (data: TQC2050_R01DetailDto[]) => set((state) => {
		let newList: TQC2050_R01DetailDto[] = [];
		let idx = 1;
		data.forEach(item => {
			newList.push({ ...defaultTQC2050_R01DetailDto, ...item, valueIndex: idx, orderIndex: idx, orderIndexSeq: idx });
			idx++;
		});
		return { ...state, originalTQC2050_R01DetailList: newList };
	}),

	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
	
	// ====== DetailTable 상태 관리 ======
	prevSampleCount: undefined,
	setPrevSampleCount: (count: number | undefined) => set({ prevSampleCount: count }),
	isEditing: false,
	setIsEditing: (editing: boolean) => set({ isEditing: editing }),
	prevTestDetails: undefined,
	setPrevTestDetails: (details: TQC2050_R01DetailDto[] | undefined) => set({ prevTestDetails: details }),

	// ====== 두 번째 DetailTable 관리 ======
	TQC2050_R01DetailList2: [],
	setTQC2050_R01DetailList2: (data: TQC2050_R01DetailDto[]) => set((state) => {
		let newList: TQC2050_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach(item => {
			newList.push({
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return { ...state, TQC2050_R01DetailList2: newList };
	}),
	insertTQC2050_R01DetailList2: (data: TQC2050_R01DetailDto[], index?: number) => set((state) => {
		const newList = [...state.TQC2050_R01DetailList2];
		let valueIndex = Math.max(0, ...newList.map(i => i.valueIndex || 0)) + 1;
		let targetOrderIndex = index ? index : 1;
		const maxSeq = Math.max(0, ...newList.filter(i => i.orderIndex === targetOrderIndex).map(i => i.orderIndexSeq || 0));
		let targetSeq = maxSeq + 1;
		const toInsert = data.map(item => ({ ...defaultTQC2050_R01DetailDto, ...item, valueIndex: valueIndex++, orderIndex: targetOrderIndex, orderIndexSeq: targetSeq }));
		if (index !== undefined) newList.splice(index, 0, ...toInsert); else newList.push(...toInsert);
		return { TQC2050_R01DetailList2: newList };
	}),
	removeTQC2050_R01DetailList2: (valueIndex: number) => set((state) => ({
		TQC2050_R01DetailList2: [...state.TQC2050_R01DetailList2].filter(item => item.valueIndex !== valueIndex)
	})),
	updateTQC2050_R01DetailList2: (valueIndex: number, data: TQC2050_R01DetailDto) => set((state) => ({
		TQC2050_R01DetailList2: state.TQC2050_R01DetailList2.map(item => item.valueIndex === valueIndex ? data : item)
	})),

	selectedTQC2050_R01DetailList2: [],
	setSelectedTQC2050_R01DetailList2: (idList: string[]) => set((state) => ({
		...state,
		selectedTQC2050_R01DetailList2: idList,
	})),
	addSelectedTQC2050_R01DetailList2: (idList: string[]) => set((state) => ({
		selectedTQC2050_R01DetailList2: [...state.selectedTQC2050_R01DetailList2, ...idList]
	})),
	removeSelectedTQC2050_R01DetailList2: (idList?: string[]) => set((state) => ({
		selectedTQC2050_R01DetailList2: [...state.selectedTQC2050_R01DetailList2].filter(v => idList ? !idList.includes(v) : false)
	})),
	initSelectedTQC2050_R01DetailList2: () => set({ selectedTQC2050_R01DetailList2: [] }),

	deletedTQC2050_R01DetailList2: [],
	setDeletedTQC2050_R01DetailList2: (idList: string[]) => set({ deletedTQC2050_R01DetailList2: idList }),
	addDeletedTQC2050_R01DetailList2: (idList: string[]) => set((state) => {
		const _deleted = [...state.deletedTQC2050_R01DetailList2];
		for (const v of idList) {
			const isInserted = state.TQC2050_R01DetailList2.find(it => it.valueIndex === Number(v) && it.inserted);
			const isModified = state.TQC2050_R01DetailList2.find(it => it.valueIndex === Number(v) && it.isModified);
			if (!isInserted && !isModified) _deleted.push(v);
		}
		return { deletedTQC2050_R01DetailList2: _deleted };
	}),
	removeDeletedTQC2050_R01DetailList2: (idList?: string[]) => set((state) => ({
		deletedTQC2050_R01DetailList2: [...state.deletedTQC2050_R01DetailList2].filter(v => idList ? !idList.includes(v) : false)
	})),

	originalTQC2050_R01DetailList2: [],
	setOriginalTQC2050_R01DetailList2: (data: TQC2050_R01DetailDto[]) => set((state) => {
		let newList: TQC2050_R01DetailDto[] = [];
		let idx = 1;
		data.forEach(item => {
			newList.push({ ...defaultTQC2050_R01DetailDto, ...item, valueIndex: idx, orderIndex: idx, orderIndexSeq: idx });
			idx++;
		});
		return { ...state, originalTQC2050_R01DetailList2: newList };
	}),

	detailColumnState2: null,
	setDetailColumnState2: (state: ColumnState[] | null) => set({ detailColumnState2: state }),

	prevSampleCount2: undefined,
	setPrevSampleCount2: (count: number | undefined) => set({ prevSampleCount2: count }),
	isEditing2: false,
	setIsEditing2: (editing: boolean) => set({ isEditing2: editing }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
	detailScrollTop2: null,
	setDetailScrollTop2: (top: number | null) => set({ detailScrollTop2: top }),

	initData: () => set((state) => ({
		...state,
		TQC2050_R01Filter: defaultTQC2050_R01Filter,
		TQC2050_R01PastFilter: defaultTQC2050_R01Filter,
		selectedTQC2050_R01: undefined,
		editTQC2050_R01: defaultTQC2050_R01HeaderDto,
		TQC2050_R01List: [],
		TQC2050_R01DetailList: [],
		deletedTQC2050_R01DetailList: [],
		selectedTQC2050_R01DetailList: [],
		originalTQC2050_R01DetailList: [],
		TQC2050_R01DetailList2: [],
		deletedTQC2050_R01DetailList2: [],
		selectedTQC2050_R01DetailList2: [],
		originalTQC2050_R01DetailList2: [],
		allCount: 0,
		prevSampleCount: undefined,
		isEditing: false,
		prevTestDetails: undefined,
		prevSampleCount2: undefined,
		isEditing2: false,
		scrollTop: null,
		detailScrollTop: null,
		detailScrollTop2: null,
	})),

	
}));

